import chatIcon from "@/assets/icons/chatbot.svg";

const state = () => ({
  messagesFromSelectedConversation: [],
  supportAgent: {
    id: "assistant",
    name: "Assistant",
    avatarUrl: chatIcon,
  },
  currentUser: {
    id: "user",
    name: "User"
  },
  isChatOverviewVisible: false,
  // PBI 11217: the read-only feedback view keeps its own messages, so "View messages" never depends on it.
  feedbackMessagesFromSelectedConversation: [],
  isFeedbackOverviewVisible: false,
  // Thumbs-down reason options from the server ({ id: flag value, description: label }); null until loaded.
  thumbsDownReasonOptions: null
});

const getters = {};
const actions = {};
const mutations = {
  setMessagesFromSelectedConversation(state, messages) {
    if (!messages || messages.length === 0)
      state.messagesFromSelectedConversation.length = 0;

    state.messagesFromSelectedConversation = messages.map((message) => ({
      id: message.messageId,
      author: message.role === "assistant" ? state.supportAgent : state.currentUser,
      conversationId: message.currentConversationId,
      timestamp: message.timestamp,
      text: message.content,
      attachments: message.attachments && message.attachments.length > 0 ? message.attachments : []
    }));
  },
	displayChatOverviewPopup(state) {
		state.isChatOverviewVisible = true;
	},
	closeChatOverviewPopup(state) {
		state.isChatOverviewVisible = false;
	},
  setFeedbackMessagesFromSelectedConversation(state, messages) {
    state.feedbackMessagesFromSelectedConversation = (messages ?? []).map(message => ({
      id: message.messageId,
      author: message.role === "assistant" ? state.supportAgent : state.currentUser,
      conversationId: message.conversationId,
      timestamp: message.timestamp,
      text: message.content,
      rating: message.rating,
      thumbsDownReason: message.thumbsDownReason,
      comment: message.comment ?? null,
      attachments: message.attachments && message.attachments.length > 0 ? message.attachments : []
    }));
  },
  displayFeedbackOverviewPopup(state) {
    state.isFeedbackOverviewVisible = true;
  },
  closeFeedbackOverviewPopup(state) {
    state.isFeedbackOverviewVisible = false;
  },
  setThumbsDownReasonOptions(state, options) {
    state.thumbsDownReasonOptions = options;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
